export default {
  name: 'Scrollbar',
  selector: '::-webkit-scrollbar',
  defaultRules: [
    {
      directives: {
        background: '--wallpaper'
      }
    }
  ]
}
